import axiosInstance from "api/axiosInstance";

/**
 * ============================================
 * GET Funnel Status
 * GET /business/business/funnel
 * ============================================
 */
export const getSellFunnelStatus = async (accessToken) => {
    try {
        const response = await axiosInstance.get(
            "/business/business/funnel",
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        return {
            ok: true,
            data: response.data,
        };
    } catch (error) {
        return {
            ok: false,
            message:
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                "دریافت وضعیت قیف فروش با خطا مواجه شد.",
        };
    }
};


/**
 * ============================================
 * Activate Funnel
 * POST /business/business/funnel/activate
 * ============================================
 *
 * payload:
 * {
 *   templateId: "uuid" | null
 * }
 */
export const funnelActivate = async (payload, accessToken) => {
    try {
        const response = await axiosInstance.post(
            "/business/business/funnel/activate",
            payload,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        return {
            ok: true,
            data: response.data,
        };
    } catch (error) {
        return {
            ok: false,
            message:
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                "فعال‌سازی قیف فروش با خطا مواجه شد.",
        };
    }
};


/**
 * ============================================
 * GET Funnel Templates
 * GET /business/business/funnel/templates
 * ============================================
 */
export const getFunnelTemplates = async (accessToken) => {
    try {
        const response = await axiosInstance.get(
            "/business/business/funnel/templates",
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        return {
            ok: true,
            data: response.data,
        };
    } catch (error) {
        return {
            ok: false,
            message:
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                "دریافت قالب‌های قیف فروش با خطا مواجه شد.",
        };
    }
};


/**
 * ============================================
 * GET Available Criteria
 * GET /business/business/funnel/available-criteria?stageOrder=X
 * ============================================
 *
 * stageOrder: 1 تا 5
 */
export const getAvailableFunnelCriteria = async (
    stageOrder,
    accessToken
) => {
    try {
        const response = await axiosInstance.get(
            "/business/business/funnel/available-criteria",
            {
                params: {
                    stageOrder,
                },
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        return {
            ok: true,
            data: response.data,
        };
    } catch (error) {
        return {
            ok: false,
            message:
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                "دریافت معیارهای قابل انتخاب با خطا مواجه شد.",
        };
    }
};


/**
 * ============================================
 * PUT Funnel Stages
 * PUT /business/business/funnel/stages
 * ============================================
 *
 * payload:
 * {
 *   stages: [
 *     {
 *       stageOrder: 1,
 *       stageName: "...",
 *       criterionId: "uuid"
 *     },
 *     ...
 *   ]
 * }
 *
 * باید دقیقاً ۵ مرحله ارسال شود.
 */
export const updateFunnelStages = async (
    payload,
    accessToken
) => {
    try {
        const response = await axiosInstance.put(
            "/business/business/funnel/stages",
            payload,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        return {
            ok: true,
            data: response.data,
        };
    } catch (error) {
        return {
            ok: false,
            message:
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                "ذخیره تنظیمات مراحل قیف فروش با خطا مواجه شد.",
        };
    }
};


/**
 * ============================================
 * POST Apply Template
 * POST /business/business/funnel/apply-template
 * ============================================
 *
 * payload:
 * {
 *   templateId: "uuid"
 * }
 */
export const applyFunnelTemplate = async (
    payload,
    accessToken
) => {
    try {
        const response = await axiosInstance.post(
            "/business/business/funnel/apply-template",
            payload,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        return {
            ok: true,
            data: response.data,
        };
    } catch (error) {
        return {
            ok: false,
            message:
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                "اعمال قالب قیف فروش با خطا مواجه شد.",
        };
    }
};


/**
 * ============================================
 * GET Funnel Dashboard
 * GET /business/business/funnel/dashboard
 * ============================================
 */
export const getSellFunnelDashboard = async (accessToken) => {
    try {
        const response = await axiosInstance.get(
            "/business/business/funnel/dashboard",
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        return {
            ok: true,
            data: response.data,
        };
    } catch (error) {
        return {
            ok: false,
            message:
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                "دریافت اطلاعات داشبورد قیف فروش با خطا مواجه شد.",
        };
    }
};


/**
 * ============================================
 * GET Funnel Customers
 * GET /business/business/funnel/customers?stage=X
 * ============================================
 *
 * stage: 1 تا 5
 */
export const getSellFunnelCustomers = async (
    stage,
    accessToken
) => {
    try {
        const response = await axiosInstance.get(
            "/business/business/funnel/customers",
            {
                params: {
                    stage,
                },
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
        return {
            ok: true,
            data: response.data,
        };
    } catch (error) {
        return {
            ok: false,
            message:
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                "دریافت مشتریان این مرحله با خطا مواجه شد.",
        };
    }
};


/**
 * ============================================
 * DELETE Funnel
 * DELETE /business/business/funnel
 * ============================================
 */
export const deleteSellFunnel = async (accessToken) => {
    try {
        const response = await axiosInstance.delete(
            "/business/business/funnel",
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        return {
            ok: true,
            data: response.data,
        };
    } catch (error) {
        return {
            ok: false,
            message:
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                "غیرفعال‌سازی قیف فروش با خطا مواجه شد.",
        };
    }
};